import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ServiceData from '../../data/service/ServiceMain.json';
import { slugify } from '../../utils';
import { getAssetPath } from '../../utils/publicPath';

const AllData = ServiceData;

const ServicePropOne = ({
  colSize = 'col-lg-4',
  serviceStyle = '',
  itemShow = AllData.length,
  marginTop = 'no',
  variant = 'default',
  services = []
}) => {
  const { t } = useTranslation();
  const translatedServices = t('services.items', { returnObjects: true }) || [];

  if (variant === 'mutawir') {
    const cards = Array.isArray(services) && services.length > 0 ? services : translatedServices;

    return (
      <>
        {cards.map((service, index) => {
          const href = service.href || (service.slug ? `/service/${service.slug}` : undefined);

          return (
            <div className="col-lg-4 col-md-6" key={index}>
              {href ? (
                <Link to={href} className="mutawir-card mutawir-card--link">
                  <h3 className="mutawir-card__title">{service.title}</h3>
                  <p className="mutawir-card__description">{service.description}</p>
                </Link>
              ) : (
                <div className="mutawir-card">
                  <h3 className="mutawir-card__title">{service.title}</h3>
                  <p className="mutawir-card__description">{service.description}</p>
                </div>
              )}
            </div>
          );
        })}
      </>
    );
  }

  const topMargin = (index) => {
    if (marginTop === 'yes') {
      if (index === 0) {
        return 'mt--200 mt_md--0';
      } else if (index === 1) {
        return 'mt--100 mt_md--0';
      }
      return 'mt--0';
    }
    return '';
  };

  const dataSource = Array.isArray(services) && services.length > 0 ? services : AllData;

  return (
    <>
      {dataSource.slice(0, itemShow).map((data, index) => (
        <div className={`${colSize} ${topMargin(index)}`} key={index}>
          <div className={`services-grid ${serviceStyle}`}>
            <div className="thumbnail">
              <img src={getAssetPath(data.image)} alt="icon" />
            </div>
            <div className="content">
              <h5 className="title">
                <Link to={`/service-details/${slugify(data.title)}`}>
                  {data.title}
                </Link>
              </h5>
              <p>{data.description}</p>
              <Link
                to={`/service-details/${slugify(data.title)}`}
                className="more-btn"
              >
                Find out more
              </Link>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ServicePropOne;
